// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Model id and prompt versions that produced an extraction. available_prompt_versions is every configured prompt; used_prompt_versions is the subset actually invoked for the document.
 * @export
 * @interface ExtractionMetadata
 */
export interface ExtractionMetadata {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExtractionMetadata
     */
    available_prompt_versions: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ExtractionMetadata
     */
    extracted_at: string;
    /**
     * 
     * @type {string}
     * @memberof ExtractionMetadata
     */
    model_id: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExtractionMetadata
     */
    used_prompt_versions: { [key: string]: string; };
}

/**
 * Check if a given object implements the ExtractionMetadata interface.
 */
export function instanceOfExtractionMetadata(value: object): value is ExtractionMetadata {
    if (!('available_prompt_versions' in value) || value['available_prompt_versions'] === undefined) return false;
    if (!('extracted_at' in value) || value['extracted_at'] === undefined) return false;
    if (!('model_id' in value) || value['model_id'] === undefined) return false;
    if (!('used_prompt_versions' in value) || value['used_prompt_versions'] === undefined) return false;
    return true;
}

export function ExtractionMetadataFromJSON(json: any): ExtractionMetadata {
    return ExtractionMetadataFromJSONTyped(json, false);
}

export function ExtractionMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractionMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'available_prompt_versions': json['available_prompt_versions'],
        'extracted_at': json['extracted_at'],
        'model_id': json['model_id'],
        'used_prompt_versions': json['used_prompt_versions'],
    };
}

export function ExtractionMetadataToJSON(json: any): ExtractionMetadata {
    return ExtractionMetadataToJSONTyped(json, false);
}

export function ExtractionMetadataToJSONTyped(value?: ExtractionMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available_prompt_versions': value['available_prompt_versions'],
        'extracted_at': value['extracted_at'],
        'model_id': value['model_id'],
        'used_prompt_versions': value['used_prompt_versions'],
    };
}
